import { render, staticRenderFns } from "./ScreenBillOfLadingExtraItemForm.vue?vue&type=template&id=57073ae6&scoped=true&"
import script from "./ScreenBillOfLadingExtraItemForm.vue?vue&type=script&lang=js&"
export * from "./ScreenBillOfLadingExtraItemForm.vue?vue&type=script&lang=js&"
import style0 from "./ScreenBillOfLadingExtraItemForm.vue?vue&type=style&index=0&id=57073ae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57073ae6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCard,VCheckbox,VChip,VCol,VContainer,VDataTable,VForm,VIcon,VRow,VSpacer,VTextField})
